import $ from 'jquery';
// import modal from 'bootstrap';
import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
// import Swiper, { Navigation, Pagination, EffectFade } from 'swiper';
gsap.registerPlugin(ScrollToPlugin, ScrollTrigger);

// スムーススクロール
const smoothScroll = () => {
	const scrollTrigger = document.querySelectorAll('a[href^="#"]');

	for (let i = 0; i < scrollTrigger.length; i++) {
		scrollTrigger[i].addEventListener('click', ev => {
			ev.preventDefault();
			const navHeight = document.querySelector('header').clientHeight;
			const targetSection = scrollTrigger[i].getAttribute('href');

			const rect = document.querySelector(targetSection).getBoundingClientRect().top;
			const offset = window.pageYOffset;
			const gap = 20;
			const target = rect + offset - navHeight - gap;

			gsap.to(window, .3, {
				scrollTo: { y: target },
				ease: 'power4.out',
			});
		});
	};
};

const spaceAutoScript = () => {
	const
		header = document.querySelector('header'),
		headerHeight = header.clientHeight,
		addMarginClass = document.querySelectorAll('.hma'),
		addPaddingClass = document.querySelectorAll('.hpa');

	for (let i = 0; i < addMarginClass.length; i++) {
		addMarginClass[i].style.marginTop = headerHeight + 'px';
	};
	for (let i = 0; i < addPaddingClass.length; i++) {
		addPaddingClass[i].style.paddingTop = headerHeight + 'px';
	};
}

const menuScript = () => {
	const
		menu = document.querySelector('.ham-menu'),
		fixedMenu = document.querySelector('.fixed-menu'),
		setClass = 'is_set',
		triggerBtn = document.querySelectorAll('.closeTrigger');

	menu.addEventListener('click', () => {
		if (menu.classList.contains(setClass)) {
			menu.classList.remove(setClass);
			fixedMenu.classList.remove(setClass);
		} else {
			menu.classList.add(setClass);
			fixedMenu.classList.add(setClass);
		};
	});

	triggerBtn.forEach(e => {
		e.addEventListener('click', () => {
			menu.classList.remove(setClass);
			fixedMenu.classList.remove(setClass);
		});
	})
};

const toggleMenuScript = () => {
	$(".toggle-menu").on("click", (e) => {
		$(e.currentTarget).children("ul").slideToggle();
		$(".toggle-menu").not($(e.currentTarget)).children("ul").slideUp();
		$(e.currentTarget).children("span").toggleClass("in_active");
	})
};

window.addEventListener('load', () => {
	smoothScroll();
	spaceAutoScript();
	menuScript();
	toggleMenuScript();
});

window.addEventListener('resize', () => {

});

window.addEventListener('scroll', () => {

});
